<template>
  <div v-if="user.pending_organisation_requests_count > 0 && canShow" class="card mb-4">
    <div class="card-body py-3 bg-highlight">
      <i v-if="isClose" @click="closeOrganisationRequest()" class="fa fa-close close-dialog t-red" ></i>
      <div class="mb-0 add-organisation block-fa-span">
        <i class="fa fa-warning t-yellow t-sm pr-1"></i>
        <p class="mb-0 t-sm t-regular d-block block-span">
          <a href="#" @click.prevent="openModalOrganisationRequest()" class="t-blue">Please confirm your organisation here.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pendingOrganisationRequest',
  props: {
    isClose: {
      type: Boolean,
      default: false
    },
    checkCookie: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      canShow: false
    }
  },
  created () {
    if (this.$can.edit('researcher', this.user.rw_access)) this.checkShow()
  },
  methods: {
    checkShow () {
      if (this.checkCookie) {
        ((!this.$ls.getAccountData() || !this.$ls.getAccountData().organisationRequestClosed))
          ? this.canShow = true
          : this.canShow = false
      } else {
        this.canShow = true
      }
    },
    openModalOrganisationRequest () {
      this.$events.$emit('modal:organisation_request:accept:open')
    },
    closeOrganisationRequest () {
      this.canShow = false
      let data = this.$ls.getAccountData()
      data.organisationRequestClosed = true
      this.$ls.setAccountData(data)
    }
  }
}
</script>
